/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions, FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptionsFromJSONTyped, FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptionsToJSON, } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions';
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsIosFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsIosFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsIosFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions(json)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsIosToJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsIosToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsIosToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions(value)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPlatformDataOptionsIos.js.map